import {
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
  useTheme,
} from "@mui/material";
import RSButton from "ds_legacy/components/RSButton";
import { HorizontalLayout } from "ds_legacy/materials/layouts";
import { margin } from "ds_legacy/materials/metrics";
import { FONT_WEIGHT_BOLD } from "ds_legacy/materials/typography";
import { InfoIcon } from "lucide-react";
import { useTranslations } from "translations";
import { CONFIRM_FAX_GDPR } from ".";
import { FilterReasons } from "./shared";

export const ConfirmFaxGDPRModal = ({
  filterReasons,
  handleConfirm,
  onClose,
  open,
}: {
  filterReasons: string;
  handleConfirm: () => void;
  onClose: () => void;
  open: boolean;
}) => {
  const translations = useTranslations();
  const theme = useTheme();
  return (
    <Dialog data-testid={CONFIRM_FAX_GDPR} open={open}>
      <DialogTitle>
        {translations.search.searchPageTables.modals.sendFax.title}
      </DialogTitle>
      <DialogContent>
        <HorizontalLayout margin={margin(0, 0, 2)}>
          <InfoIcon
            style={{
              color: theme.palette.warning.main,
              margin: margin(0, 1, 0, 0),
            }}
          />
          <DialogContentText fontWeight={FONT_WEIGHT_BOLD}>
            {translations.search.searchPageTables.modals.sendFax.warning}
          </DialogContentText>
        </HorizontalLayout>
        <FilterReasons filterReasons={filterReasons} />
        <DialogContentText>
          {translations.search.searchPageTables.modals.sendFax.subtitle}
        </DialogContentText>
      </DialogContent>
      <DialogActions disableSpacing>
        <RSButton
          color="primary"
          id="cancel"
          loading="na"
          variant="text"
          onClick={onClose}
        >
          {translations.search.searchPageTables.modals.sendFax.buttonCancel}
        </RSButton>
        <RSButton
          color="primary"
          id="confirm"
          inverted
          loading="na"
          variant="text"
          onClick={handleConfirm}
        >
          {translations.search.searchPageTables.modals.sendFax.buttonConfirm}
        </RSButton>
      </DialogActions>
    </Dialog>
  );
};
